import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class EhlerFisherSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForEF = this.yAccessorForEF.bind(this);
    this.yAccessorForTrigger = this.yAccessorForTrigger.bind(this);
  }
  yAccessorForEF(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).ef;
  }
  yAccessorForTrigger(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).trigger;
  }
  render() {
    const { className, onDoubleClick, onContextMenu } = this.props;
    const { strokeEF, strokeTrigger, strokeZeroLine } = this.props;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorForEF}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeEF}
        />
        <LineSeries
          yAccessor={this.yAccessorForTrigger}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeTrigger}
        />
        <StraightLine
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeZeroLine}
          yValue={0}
        />
      </g>
    );
  }
}

EhlerFisherSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  strokeEF: PropTypes.object.isRequired,
  strokeTrigger: PropTypes.object.isRequired,
  strokeZeroLine: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

EhlerFisherSeries.defaultProps = {
  className: "react-stockcharts-ehler-fisher-series",
};

export default EhlerFisherSeries;
